import { t } from '@/i18n/utils'

/**
 * Welfare 页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const welfareCommonConfig = {
  texts: {
    get myWallet() { return t('MyWallet') },
    get coins() { return t('coins') },
    get dailyCheckIn() { return t('DailyCheckIn') },
    // 与 en.json 不完全匹配
    get youHaveCheckedIn() { return t('youHaveCheckedIn') },
    // 与 en.json 不完全匹配
    get dayStraight() { return t('dayStraight') },
    get checkIn() { return t('CheckInButton') },
    get tomorrowToGetMore() { return t('GetTomorrow') },
    // 与 en.json 不完全匹配（'Tomorrow Check in {0}' 带参数）
    get tomorrowCheckIn() { return t('tomorrowCheckIn') },
    get tasks() { return t('Tasks') },
    // 与 en.json 不完全匹配
    get checkInGet() { return t('checkInGet') },
    get get() { return t('GetCoins1') },
    get ok() { return t('OK') },
    get go() { return t('GO') },
    // 与 en.json 不完全匹配（'Day {0}' 带参数）
    day(day: number) { return t('day', { day }) },
    // WelfareGuideAddScreen 文案
    get guideAddStep1() { return t('Click') },
    get guideAddStep2() { return t('Share') },
    get guideAddStep3() { return t('AddToScreen') },
    // 与 en.json 不完全匹配
    get guideAddAtTopRight() { return t('guideAddAtTopRight') },
    // 与 en.json 不完全匹配
    get guideAddAtBottom() { return t('guideAddAtBottom') },
    get guideAddAtBottomRight() { return t('AtBottomRight') },
    // 与 en.json 不完全匹配（引号形式不同）
    get guideAddShare() { return t('guideAddShare') },
    // 与 en.json 不完全匹配（引号形式不同）
    get guideAddToScreen() { return t('guideAddToScreen') },
    // WelfareGuideOpen 文案
    get guideOpenTitle() { return t('MenuExplain') },
    get guideOpenAction() { return t('OpenInExternalBrowser') },
    // ↓ NovelMello 使用（其它品牌视图不渲染，零影响）
    get rewardsTitle() { return t('RewardsTab') },
    get today() { return t('Today') },
    // ↓ Moonpage 使用（其它品牌视图不渲染，零影响）
    moonpageStreakActive(day: number) { return t('moonpageStreakActive', { day }) },
    get moonpageStreakStart() { return t('moonpageStreakStart') },
    get moonpageShowRules() { return t('moonpageShowRules') },
    get moonpageRuleDaily() { return t('moonpageRuleDaily') },
    get moonpageRuleBonus() { return t('moonpageRuleBonus') },
    get moonpageRuleReset() { return t('moonpageRuleReset') },
    get moonpageToday() { return t('Today') },
    get moonpageCompleted() { return t('Completed') },
    get moonpageBonusReward() { return t('moonpageBonusReward') },
    get moonpageCoinReward() { return t('moonpageCoinReward') },
    get moonpageDay7Bonus() { return t('moonpageDay7Bonus') },
    moonpageCheckIn(amount: number) { return t('moonpageCheckIn', { amount }) },
    get moonpageCheckedInToday() { return t('moonpageCheckedInToday') },
    moonpageNextCheckIn(countdown: string) { return t('moonpageNextCheckIn', { countdown }) },
    moonpageComeBackTomorrow(reward: number) { return t('moonpageComeBackTomorrow', { reward }) },
    get moonpageCoinsEarned() { return t('moonpageCoinsEarned') },
    get moonpageCheckedIn() { return t('moonpageCheckedIn') },
    moonpageStreakDay(day: number) { return t('moonpageStreakDay', { day }) },
    get moonpageNiceContinue() { return t('moonpageNiceContinue') },
    get moonpageSignedNoticeTitle() { return t('moonpageSignedNoticeTitle') },
    get moonpageSignedNoticeText() { return t('moonpageSignedNoticeText') },
    get moonpageWhileWait() { return t('moonpageWhileWait') },
    get moonpageBrowseGenres() { return t('moonpageBrowseGenres') },
    get moonpageGotIt() { return t('moonpageGotIt') },
    get moonpageClose() { return t('Close') },
  },
}
